import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  connect(): void {
    this.element.addEventListener('toggle', (event: Event) => {
      const isOpen = (event as ToggleEvent).newState === 'open'
      if (!isOpen) return

      const allButtons = this.element.querySelectorAll('button')
      const lastButton = allButtons[allButtons.length - 1]
      lastButton?.focus()
    })
  }

  hide(e: MouseEvent): void {
    e.preventDefault()
    this.element.hidePopover()
  }
}
